/**
 * Field formatters and display labels for the ATO/SRO change-history feed.
 *
 * Used by: `AtoSroPanel.tsx` -> `<ChangeHistory />`.
 */

const AUTHORITY_LABELS: Record<string, string> = {
  ato: "ATO",
  sro_nsw: "Revenue NSW",
  sro_vic: "SRO Victoria",
  sro_qld: "QRO Queensland",
  sro_wa: "RevenueWA",
  sro_sa: "RevenueSA",
  sro_tas: "SRO Tasmania",
  sro_act: "ACT Revenue",
  sro_nt: "NT Revenue",
  other: "Other authority",
};

export const ATO_SRO_FIELD_FORMATTERS: Record<
  string,
  (value: unknown) => string
> = {
  authority: (v) => AUTHORITY_LABELS[String(v)] ?? String(v ?? "\u2014"),
  authorityLabel: (v) => String(v ?? "\u2014"),
  notes: (v) => String(v ?? "\u2014"),
  confidence: (v) =>
    typeof v === "number" ? `${Math.round(v * 100)}%` : String(v ?? "\u2014"),
};

export const ATO_SRO_FIELD_LABELS: Record<string, string> = {
  authority: "Authority",
  authorityLabel: "Authority label",
  notes: "Notes",
  confidence: "Confidence",
};
